//const fds=
const api_host=process.env.REACT_APP_API
export const saveTemplateAdd = (user, token, name, desc, upload, code, method, ...args) => 

fetch(api_host+`/reporte/general/Template/?user=${user}&name=${name}&token=${token}&desc=${desc}&method=${method}&args=${args}`, {method:'POST', body:JSON.stringify({"upload":upload, "code":code})})
.then(response => response.json())

export const templateView = (user, token) => 
fetch(api_host+`/reporte/general/Template/?user=${user}&token=${token}&method=view`)
.then(response => response.json())

export const templateDelete= (user, token, id) => 
fetch(api_host+`/reporte/general/Template/?user=${user}&token=${token}&method=delete&id=${id}`)
.then(response => response.json())